
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppButton, AppDateTimePicker } from '@/components';
import useGiftLucky from '@/modules/gift/model/lucky';
import { timeUnits } from '@/common/utils/helpers';
import { ROUTE_NAME_GIFT } from '@/modules/gift/router';

export default defineComponent({
    name: ROUTE_NAME_GIFT.LUCKY,
    components: { AppFormRow, AppInput, AppSelect, AppButton, AppCard, AppDateTimePicker },
    setup() {
        const { model, v$, fetch, actions } = useGiftLucky();

        onMounted(async () => {
            await fetch();
        });

        return { v$, timeUnits, model, actions };
    }
});
